import { useEffect, useMemo, useCallback } from "react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import CustomForm from "components/Common/Form";
import { DOCTOR_OPD_CHARGE_ROUTER_FORM_CONFIG } from "./config";
import { useAlert } from "context/alert";
import zoneLocalStorageId from "utils/zone";
import Loader from "components/Common/loader";
import {
  createDoctorOpdChargeRouter,
  updateDoctorOpdChargeRouter,
} from "services/doctorOPDChargeRouter";
import { useSelector } from "react-redux";

const AddDoctorOPDChargeRouter = ({ onClose, rowData }) => {
  const {
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: useMemo(() => rowData, [rowData]),
  });

  const { user } = useSelector((state) => state.jwtAuthreducer);

  const { showAlert } = useAlert();

  const onSuccess = () => {
    const shouldRefetch = true;

    const message = rowData
      ? "Doctor OPD Charge Router updated successfully!"
      : "Doctor OPD Charge Router created successfully!";

    showAlert(message, "success");
    onClose(shouldRefetch);
  };

  const onError = useCallback(
    (error) => {
      const errorMessage =
        error?.response?.data?.message || "Something went wrong!";
      const errorDetail = error?.response?.data?.detail;

      showAlert(errorMessage, "danger", errorDetail);
    },
    [showAlert],
  );

  const { mutate: createRouter, isLoading: isCreating } = useMutation({
    mutationFn: createDoctorOpdChargeRouter,
    onSuccess,
    onError,
  });

  const { mutate: updateRouter, isLoading: isUpdating } = useMutation({
    mutationFn: updateDoctorOpdChargeRouter,
    onSuccess,
    onError,
  });

  const isSubmitting = isCreating || isUpdating;

  const handleSubmitRouter = (values, e) => {
    e.preventDefault();
    console.log("values", values);
    const payload = {
      doctor_id: values?.refer_doctor_id,
      clinic_id: values?.clinic_id,
      opd_fee: values?.opd_fee,
      valid_from: values?.valid_from,
      valid_till: values?.valid_till,
      zone_id: values?.zone_id || zoneLocalStorageId(),
      created_by:
        user?.employee_code_id || localStorage.getItem("employee_code_id"),
      is_active: true,
    };

    if (rowData) {
      updateRouter({
        id: rowData?.id,
        ...payload,
      });
    } else {
      createRouter(payload);
    }

    reset();
  };

  useEffect(() => {
    reset(rowData);
  }, [rowData, reset]);

  return (
    <div style={{ position: "relative" }}>
      {isSubmitting && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Loader isLoading={true} />
        </div>
      )}

      <CustomForm
        config={DOCTOR_OPD_CHARGE_ROUTER_FORM_CONFIG(rowData)}
        onSubmit={handleSubmitRouter}
        columnCount={2}
        rowData={rowData}
        disabled={isSubmitting}
      />
    </div>
  );
};

export default AddDoctorOPDChargeRouter;
